import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { BonusDetailsComponent } from './bonus-details.component';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';


@NgModule({
  declarations: [
    BonusDetailsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    DateDefaultFormatPipe,
  ]
})
export class BonusDetailsModule { }